import _ from 'lodash';

import { setError } from '../App/ErrorsActions';
import { mapData } from '../CFD/CFDActions';
import { calculateAvgFe } from '../FlowEfficiency/FlowEfficiencyActions';
import customFieldsUtils from '../../util/customFieldsUtils';
import CalculationsWorker from '../../services/worker';

export const LOADING = 'OVERVIEW_LOADING';
export const OVERVIEW_TYPE = 'OVERVIEW_TYPE';
export const DATA = 'OVERVIEW_DATA';
export const CFD_STATS = 'OVERVIEW_CFD_STATS';
export const AVG_FE = 'OVERVIEW_AVG_FE';
export const OVERVIEW_STATS = 'OVERVIEW_STATS';

function isLoading() {
  return {
    type: LOADING
  };
}

function success(chart, data) {
  return {
    type: DATA,
    chart,
    data
  };
}

function stats(data) {
  return {
    type: OVERVIEW_STATS,
    data
  }
}

export function getData() {

  const METRICS = {};

  function metric(name) {
    if (METRICS[name]) {
      const value = Math.floor((+new Date()-METRICS[name]) / 1000);
      const minutes = Math.floor(value / 60);
      const seconds = value % 60;
      METRICS[name] = `${minutes} min. ${seconds} sec`;
    } else {
      METRICS[name] = +new Date();
    }
  }

  return async (dispatch, getState) => {
    metric('OVERVIEW');

    dispatch(isLoading());

    const { selected } = getState().dashboards;
    const { data } = getState().app;   
    const { user } = getState().auth;

    const allFilters = getState().filters;
    const { allCustomFields, enabledColors, excludeWeekends, workStart, workEnd, holidays, dates, cta } = allFilters;
    const filters = allFilters.overview;

    filters.selectedLists = _.filter(filters.selectedLists, l => {
      return _.indexOf(selected.todo, l._id) === -1;
    });

    const customFields = customFieldsUtils.getSelected(allCustomFields, filters);

    metric('INIT WORKER');
    const service = new CalculationsWorker();
    let worker = service.wrap();
    worker = await new worker(selected, data, enabledColors, {
      enableDoneFilters: user.config.enableDoneFilters,
      enableUnmappedListsActivities: user.config.enableUnmappedListsActivities
    });
    metric('INIT WORKER');   

    const getCfd = () => {
      metric('CFD');
      return new Promise(async resolve => {
        try {
          const cfdData = await worker.CFD({
            from: dates.startDate.toISOString(),
            to: dates.endDate.toISOString(),
            lists: filters.selectedLists,
            labels: filters.selectedLabels,
            members: filters.selectedMembers,
            customFields,
            skipCardDetails: true
          });
          dispatch(success('cfd', cfdData));

          const stats = await worker.CalculateCfdStats({
            lists: filters.selectedLists,
            labels: filters.selectedLabels,
            members: filters.selectedMembers,
            excludeWeekendOpts: {
              type: excludeWeekends,
              workStart,
              workEnd,
              holidays
            },
            customFields,
            from: dates.startDate.toISOString(),
            to: dates.endDate.toISOString(),
            data: cfdData, //mapData(cfdData, data.lists, filters.selectedLists)
            useWorkingHoursInCycleTimeDays: user.config && user.config.useWorkingHoursInCycleTimeDays
          });
          dispatch({
            type: CFD_STATS,
            stats
          });
          metric('CFD');
          return resolve();
        } catch (err) {
          dispatch(setError(err));
        }
      });
    };

    const getCtsp = () => {
      metric('CTSP');
      return new Promise(async resolve => {
        try {
          let ctspData = await worker.CycleTimeScatterPlot({
            lists: filters.selectedLists,
            labels: filters.selectedLabels,
            members: filters.selectedMembers,
            customFields,
            from: dates.startDate.toISOString(),
            to: dates.endDate.toISOString(),
            timeUnit: 'day',
            blockedTime: 'all',
            color: true,
            excludeWeekendOpts: {
              type: excludeWeekends,
              workStart,
              workEnd,
              holidays
            },
            percentiles: allFilters.allPercentileValues,
            useWorkingHoursInCycleTimeDays: user.config && user.config.useWorkingHoursInCycleTimeDays
          });
          dispatch(success('ctsp', ctspData));
          metric('CTSP');
          return resolve();
        } catch (err) {
          dispatch(setError(err));
        }
      });
    };

    const getCtb = () => {
      metric('CTB');
      return new Promise(async resolve => {
        try {
          const ctbData = await worker.CycleTimeBreakdown({
            lists: filters.selectedLists,
            labels: filters.selectedLabels,
            members: filters.selectedMembers,
            customFields,
            from: dates.startDate.toISOString(),
            to: dates.endDate.toISOString(),
            timeUnit: 'week',
            blockedTime: 'all',
            excludeWeekendOpts: {
              type: excludeWeekends,
              workStart,
              workEnd,
              holidays
            },
            useWorkingHoursInCycleTimeDays: user.config && user.config.useWorkingHoursInCycleTimeDays
          });
          dispatch(success('ctb', ctbData));
          metric('CTB');
          return resolve();
        } catch (err) {
          dispatch(setError(err));
        }
      });
    };

    const getCth = () => {
      metric('CTH');
      return new Promise(async resolve => {
        try {
          let cthData = await worker.CycleTimeHistogram({
            lists: filters.selectedLists,
            labels: filters.selectedLabels,
            members: filters.selectedMembers,
            customFields,
            excludeWeekendOpts: {
              type: excludeWeekends,
              workStart,
              workEnd,
              holidays
            },
            from: dates.startDate.toISOString(),
            to: dates.endDate.toISOString(),
            timeUnit: 'day',
            blockedTime: 'all',
            percentiles: undefined,
            useWorkingHoursInCycleTimeDays: user.config && user.config.useWorkingHoursInCycleTimeDays
          });
          dispatch(success('cth', cthData));
          metric('CTH');
          return resolve();
        } catch (err) {
          dispatch(setError(err));
        }
      });
    };

    const getCta = () => {
      metric('CTA');
      return new Promise(async resolve => {
        try {
          const ctaData = await worker.CycleTimeAging({
            lists: filters.selectedLists,
            labels: filters.selectedLabels,
            members: filters.selectedMembers,
            customFields,
            excludeWeekendOpts: {
              type: excludeWeekends,
              workStart,
              workEnd,
              holidays
            },
            startDate: dates.startDate.toISOString(),
            endDate: dates.endDate.toISOString(),
            date: dates.singleDate.toISOString(),
            timeUnit: 'day',
            color: true,
            blockedTime: 'all',
            percentiles: undefined,
            healthZones: cta.selectedHealthZones,
            getSingle: true,
            useWorkingHoursInCycleTimeDays: user.config && user.config.useWorkingHoursInCycleTimeDays
          });

          for await (const point of ctaData) {
            dispatch(success('cta', point));
          }
          metric('CTA');
          return resolve();
        } catch (err) {
          dispatch(setError(err));
        }
      });
    };

    const getTrc = () => {
      metric('TRC');
      return new Promise(async resolve => {
        try {
          let tData = await worker.Throughput({
            lists: filters.selectedLists,
            labels: filters.selectedLabels,
            members: filters.selectedMembers,
            customFields,
            excludeWeekendOpts: {
              type: excludeWeekends,
              workStart,
              workEnd,
              holidays
            },
            color: true,
            timeUnit: 'day',
            blockedTime: 'all',
            from: dates.startDate.toISOString(),
            to: dates.endDate.toISOString()
          });
          dispatch(success('trc', tData));
          metric('TRC');
          return resolve();
        } catch (err) {
          dispatch(setError(err));
        }
      });
    };

    const getAvgFe = () => {
      metric('AVGFE');
      return new Promise(async resolve => {
        try {
          let ctspData = await worker.CycleTimeScatterPlot({
            lists: filters.selectedLists,
            labels: filters.selectedLabels,
            members: filters.selectedMembers,
            customFields,
            from: dates.startDate.toISOString(),
            to: dates.endDate.toISOString(),
            blockedTime: 'all',
            excludeWeekendOpts: {
              type: excludeWeekends,
              workStart,
              workEnd,
              holidays
            },
            percentiles: allFilters.allPercentileValues,
            useWorkingHoursInCycleTimeDays: user.config && user.config.useWorkingHoursInCycleTimeDays
          });
          dispatch(calculateAvgFe(ctspData.series, AVG_FE));
          metric('AVGFE');
          return resolve();
        } catch (err) {
          dispatch(setError(err));
        }
      });
    }

    let promises = [
        getCfd(),
        getCtsp(),
        getAvgFe(),
        getCtb(),
        getCth(),
        getCta(),
        getTrc()        
      ];

    await Promise.all(promises);
    metric('OVERVIEW');
    dispatch(stats(METRICS));
  };
}
